module.exports = __webpack_public_path__ + "static/media/logo.71ceddd5.png";